import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M15.5 15.38V8.62L18.88 12l-3.38 3.38",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M15.5 15.38V8.62L18.88 12l-3.38 3.38M14 19l7-7-7-7v14zm-4 0V5l-7 7 7 7z"
}, "1")], 'SwitchRightTwoTone');